import React from 'react';
import TableLegend from "./table-legend.jsx";

const TableBody = ({title, id, span = "", vehicle = false, showLegend = true}) => {
    return (
        <>
            <div className="chart-report" title={title}>
                <span id={`${id}-title`} className="chart-title " htmlFor={id} >{vehicle ? span : title}</span>
                <div className="mt-3" id={id}></div>
                {showLegend &&
                    <TableLegend data={"* Interaja com a legenda para verificar os sentidos isoladamente."}/>
                }
            </div>

            <div className="chart-divisor"></div>
        </>
    );
};

export default TableBody;